import cable from "actioncable";

let consumer;

function createChannel(...args) {
  if (!consumer) {
    consumer = cable.createConsumer($('meta[name=action-cable-url]').attr('content'));
  }

  if (document.getElementsByName("page_id")[0]) {
    return consumer.subscriptions.create(...args);
  }
}

export default createChannel;
